export default "<p>kunden-filter-gruppen-zuweisung works!</p>\r\n";